<template>
  <b-button
    variant="info"
    @click="login"
    :disabled="!loginable"
    block
  >
    ログイン
  </b-button>
</template>

<script>
export default {
  data () {
    return {
      modelName: 'login'
    }
  },

  computed: {
    loginable () {
      return this.$store.getters[`${this.modelName}/loginable`]
    }
  },

  methods: {
    async login () {
      this.$store.dispatch('loading/show')
      const result = await this.$store.dispatch(`${this.modelName}/login`)
      this.$store.dispatch('loading/hide')

      if (result) {
        this.$store.dispatch('toast/show', {
          content: 'ログインしました。',
          title: 'ログイン'
        })

        this.$router.push({ name: 'users' })
      }
    }
  }
}
</script>
